import { BrowserRouter, Route, Routes } from 'react-router'
import { MainLayout } from '@/components/layout'
import PageSeo from '@/hooks/usePageSeo'
import {
  HomePage,
  NotFoundPage,
  AboutPage,
  ServicesPage,
  ConsultationsPage,
  ScansPage,
  IntegratedHealthPage,
  CoursesPage,
  WorkWithMePage,
  WomensHealthPage,
  ChronicHealthPage,
  BooksPage,
  TrainingPage,
  ProductsPage,
  BlogPage,
  ContactPage,
} from '@/pages'
import { ROUTES } from '@/constants/routes'

const GlobalRoute = () => (
  <BrowserRouter>
    <PageSeo />
    <Routes>
      <Route element={<MainLayout />}>
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.ABOUT} element={<AboutPage />} />
        <Route path={ROUTES.SERVICES} element={<ServicesPage />} />
        <Route path={ROUTES.SERVICES_CONSULTATIONS} element={<ConsultationsPage />} />
        <Route path={ROUTES.SERVICES_SCANS} element={<ScansPage />} />
        <Route path={ROUTES.SERVICES_INTEGRATED_HEALTH} element={<IntegratedHealthPage />} />
        <Route path={ROUTES.SERVICES_COURSES} element={<CoursesPage />} />
        <Route path={ROUTES.WORK_WITH_ME} element={<WorkWithMePage />} />
        <Route path={ROUTES.WOMENS_HEALTH} element={<WomensHealthPage />} />
        <Route path={ROUTES.CHRONIC_HEALTH} element={<ChronicHealthPage />} />
        <Route path={ROUTES.BOOKS} element={<BooksPage />} />
        <Route path={ROUTES.TRAINING} element={<TrainingPage />} />
        <Route path={ROUTES.PRODUCTS} element={<ProductsPage />} />
        <Route path={ROUTES.BLOG} element={<BlogPage />} />
        <Route path={ROUTES.CONTACT} element={<ContactPage />} />
        <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
      </Route>
    </Routes>
  </BrowserRouter>
)

export default GlobalRoute
